// src/blocks/label/label.tsx
import { jsx } from "react/jsx-runtime";
var Label = ({ className, id, text }) => {
  if (!text) return null;
  return /* @__PURE__ */ jsx("div", { className, id, children: text && /* @__PURE__ */ jsx("span", { children: text }) });
};
var label_default = Label;

export {
  label_default
};
